import React, { useContext, useState, useEffect } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Pagination from '../Common/Pagination';
import Copy from '../Common/Copy';
import Swal from 'sweetalert2';


export default function MemberReport() {
  const { togel, setTogel, isSidebarEnabled, setIsSidebarEnabled, formatDateTime,toastError,toastSuccess } = useContext(GMCContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [newaddressFilter, setnewAddressFilter] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [withdrawalStatus, setWithdrawalStatus] = useState(true);
  const [editData, setEditData] = useState({ username: "", toname: "", ref_address: "" });

const [showModal, setShowModal] = useState(false);
  const [selectedUserps, setSelectedUserps] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [updating, setUpdating] = useState(false);
  const [selectedUseremail, setSelectedUseremail] = useState(null);
  const [showmailModal, setShowmailModal] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [updatingemail, setUpdatingemail] = useState(false);

  const handleEditpsClick = (user) => {
    // console.log('user',user);
    setSelectedUserps(user);
    setNewPassword("");
    setShowModal(true);
  };
  const handleUpdatePassword = async () => {
    if (!newPassword) {
      toastError("Enter Password");
      return;
    }
    try {
      setUpdating(true);
      // console.log('selectedUser.username',selectedUser.username,newPassword);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "updateps",
        username: selectedUserps.username,
        password: newPassword,
        key: process.env.REACT_APP_KEY,
      });
      console.log('res.data of update ps', res.data);
      if (res.data?.resCode === 200) {
        toastSuccess("Password updated successfully");
        setShowModal(false);
        getData();
      } else {
        toastError(res.data?.error || "Failed to update password");
      }
    } catch (err) {
      toastError("Server error");
    } finally {
      setUpdating(false);
    }
  };
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const handleEditemailClick = (user) => {
    // console.log('user',user);
    setSelectedUseremail(user);
    setNewEmail("");
    setShowmailModal(true);
  };
  const handleUpdateEmail = async () => {
    if (!newEmail) {
      toastError("Enter Email");
      return;
    }
    if (!validateEmail(newEmail)) {
      toastError("Invalid email format");
      return;
    }
    try {
      setUpdatingemail(true);
      // console.log('selectedUser.username',selectedUser.username,newEmail);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "admin",
        submethod: "updatemail",
        username: selectedUseremail.username,
        email: newEmail,
        key: process.env.REACT_APP_KEY,
      });
      console.log('res.data of update ps', res.data);
      if (res.data?.resCode === 200) {
        toastSuccess("Email updated successfully");
        setShowmailModal(false);
        getData();
      } else {
        toastError(res.data?.error || "Failed to update Email");
      }
    } catch (err) {
      toastError("Server error");
    } finally {
      setUpdatingemail(false);
    }
  };


  const onCheckboxChange = (e, username, status) => {
    const isChecked = e.target.checked;

    Swal.fire({
      title: isChecked ? 'Block User' : 'Unblock User',
      html: `Are you sure you want to ${isChecked ? 'block' : 'unblock'} <strong>${username}</strong>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        handleBlockChange(isChecked, username, status);
      } else {
        // Revert checkbox if canceled
        e.target.checked = !isChecked;
      }
    });
  };


  const handleBlockChange = async (isChecked, username, status) => {
    try {
      // console.log('ischeked', isChecked);
      status = isChecked;

      await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "admin",
        submethod: "block",
        key: process.env.REACT_APP_KEY,
        username: username,
        status: status  // or use `blocked: isChecked` if that's your schema
      });

      getData();
    } catch (err) {
      console.error("Error sending block data:", err);
    }
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setEditData({
      ref_address: user.ref_address || "",
      username: user.username || "",
      toname: user.toname || ""
    });
  }

  const handleWithdrawalStatusChange = async (event, username) => {
    const isChecked = event.target.checked;

    try {
      await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "admin",
        submethod: "withdrawalstatus",
        key: process.env.REACT_APP_KEY,
        username: username,
        status: isChecked, // Send true or false
      });

      // console.log("Updated withdrawal status for:", username, isChecked);

      // Update local state
      setWithdrawalStatus(prev => ({
        ...prev,
        [username]: isChecked
      }));

      // Optional: Refresh data from server
      getData();
    } catch (error) {
      console.error("Error updating withdrawal status:", error);
    }
  };


  const closeModal = () => {
    setSelectedUser(null);
  }


  const updateData = async () => {
    try {
      const ress = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "admin",
        submethod: "updaterefer",
        key: process.env.REACT_APP_KEY,
        search: search,
        page: currentPage,
        pageSize: pageSize,
        username: editData.username,
        newreferral: newaddressFilter,

      });
      // console.log('res', editData.username);
      setSelectedUser(null);
      getData()
    } catch (error) {
      console.log("error : ", error);
    }

  }


  const handleChange = (e) => {
    setnewAddressFilter(e.target.value);
  };


  // Fetch data function
  const getData = async () => {

    try {
      setLoading(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "get",
        key: process.env.REACT_APP_KEY,
        search: search,
        page: currentPage,
        pageSize: pageSize,

      });
      // console.log('serarch', search)
      setLoading(false);
      if (res.data.error) return;
      console.log('res.data.data', res.data.data)

      setData(res.data.data);
      setPages(Math.ceil(res.data.total / pageSize));
      // if (res.data.data.length > 0) {
      //   const firstUser = res.data.data[0].username; // Get first username
      // updateData(firstUser); // Pass username to updateData
      // }
    } catch (err) {
      console.log("Error : ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [pageSize, currentPage, search]);

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1); // Reset to page 1 if currentPage is out of range
    }
  }, [pages]);

  return (
    <>
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        <div className="vertical-overlay" onClick={() => setIsSidebarEnabled((prev) => !prev)} />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid" >
              {/* Page Title Section */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                      <li className="breadcrumb-item active">Member Report</li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* Member Report Table Section */}
              <div className="row">
                <div className="col-lg-12" onClick={() => setIsDarkMode((prev) => !prev)}>
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Member Report</h4>
                    </div>
                    <div className="card-body">
                      <div className="listjs-table" id="customerList">
                        {/* Table Action Buttons */}
                        <div className="row g-4 mb-3">
                          <div className="col-sm-auto">

                          </div>
                          <div className="col-sm">
                            <div className="d-flex justify-content-sm-end">
                              <div className="search-box ms-2">
                                <input
                                  type="text"
                                  className="form-control search"
                                  placeholder="Search..."
                                  onChange={(e) => setSearch(e.target.value)}
                                />
                                <i className="ri-search-line search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Table */}
                        <div className="table-responsive table-card mt-3 mb-1">
                          <table className="table align-middle table-nowrap" id="customerTable">
                            <thead className="table-light">
                              <tr>
                                <th className="gridjs-th text-center">#</th>
                                <th className="gridjs-th text-center">From User</th>
                                <th className="gridjs-th text-center">To User</th>
                                <th className="gridjs-th text-center">Total Staking</th>
                                <th className="gridjs-th text-center">Level Reward</th>
                                <th className="gridjs-th text-center">Pool Reward</th>
                                <th className="gridjs-th text-center">Weekly Reward</th>
                                <th className="gridjs-th text-center">Re-Stake Status</th>
                                <th className="gridjs-th text-center">Status</th>
                                <th className="gridjs-th text-center">Team</th>
                                <th className="gridjs-th text-center">Joining Date</th>
                                <th className="gridjs-th text-center">Action</th>
                                <th className="gridjs-th text-center">Withdrawal Status</th>
                                <th className="gridjs-th text-center">Blocked Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.length > 0 ? (
                                data.map((ele, i) => {
                                  const index = currentPage * pageSize - pageSize + (i + 1);
                                  return (
                                    <tr key={i}>
                                      <td className="gridjs-td text-center">{index} </td>
                                      <td className="gridjs-td text-center">
                                        <div>
                                          <a
                                            target="_blank"
                                            className="text-primary"
                                            href={`${process.env.REACT_APP_EXPLORER}/address/${ele.username}`}
                                            rel="noreferrer"
                                          >
                                            <span className="name-title">Username:</span> {ele.username}
                                          </a>
                                          <Copy data={ele.username} />
                                        </div>
                                             <span className="name-title">Password:</span> {ele.password} <Copy data={ele.password} />
                                        <div className="username-name">
                                          <span className="name-title">Name:</span> {ele.fromname || "-"}
                                          <Copy data={ele.fromname} />
                                        </div>
                                        <div className="username-name">
                                          <span className="name-title">Email:</span> {ele.email || "-"}

                                        </div>
                                      </td>
                                      <td className="gridjs-td text-center">
                                        <div>
                                          <a
                                            target="_blank"
                                            className="text-primary"
                                            href={`${process.env.REACT_APP_EXPLORER}/address/${ele.ref_address}`}
                                            rel="noreferrer"
                                          >
                                            <span className="name-title">Address:</span>{ele.ref_address}
                                          </a>
                                          <Copy data={ele.ref_address} />
                                        </div>
                                        <div className="ref-name">
                                          <span className="name-title">Name:</span> {ele.toname || "-"}
                                          <Copy data={ele.toname} />
                                        </div>
                                      </td>
                                      <td className="gridjs-td text-center">${ele.totalstake || "0"}</td>
                                      <td className="gridjs-td text-center">${ele.level_rew || "0"}</td>
                                      <td className="gridjs-td text-center">${ele.pool_rew || "0"}</td>
                                      <td className="gridjs-td text-center">${parseFloat(ele.week_rew).toFixed(2) || "0"}</td>
                                      <td className="gridjs-td text-center">
                                        <span className={`badge ${ele.restake ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}>
                                          {ele.restake ? "Active" : "Deactive"}
                                        </span>
                                      </td>
                                      <td className="gridjs-td text-center">
                                        <span className={`badge ${ele.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}>
                                          {ele.status ? "Active" : "Deactive"}
                                        </span>
                                      </td>
                                      <td class="gridjs-td text-center">{ele.team || "0"}</td>
                                      <td className="gridjs-td text-center">{formatDateTime(ele.date)}</td>
                                      <td className="gridjs-td text-center">
                                        <div className="d-flex justify-content-center gap-2">

                                          {/* View Button */}
                                          <Link
                                            to={`/userreport/${ele.username}`}
                                            className="btn btn-primary btn-sm"
                                            title="View User Report"
                                          >
                                            <i className="ri-eye-line"></i>
                                          </Link>

                                          {/* Edit Button */}
                                          {/* {parseFloat(ele.totalstake) === 0 && ele.team === 0 && (
                                            <button
                                              className="btn btn-sm btn-success"
                                              title="Edit User"
                                              onClick={() => handleEditClick(ele)}
                                            >
                                              <i className="ri-ball-pen-line"></i>
                                            </button>
                                          )} */}

                                        </div>
                                              <br />
                                          {/* Login Button */}
                                          <button
                                            className="btn btn-sm btn-outline-info"
                                            title="Login as User"
                                            onClick={() =>
                                              window.open(
                                                
                                                `https://app.getlink.world/?username=${ele.username}&password=${ele.password}`,
                                                "_blank"
                                              )
                                            }
                                          >Login
                                            {/* <i className="ri-login-box-line"></i> */}
                                          </button>
                                      </td>

                                      <td className="gridjs-td text-center"> <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={ele.withdrawal_status} // safely fallback to false
                                          onChange={(e) => handleWithdrawalStatusChange(e, ele.username)}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      {/* <div className="d-flex justify-content-center gap-2">
                                          <button
                                            className="btn btn-sm btn-warning"
                                            title="Edit Email"
                                            onClick={() => handleEditemailClick(ele)}
                                          >
                                            <i class="bi bi-envelope"></i>
                                          </button>
                                          <button
                                            className="btn btn-sm btn-dark"
                                            title="Edit Password"
                                            onClick={() => handleEditpsClick(ele)}
                                          >
                                            <i class="bi bi-key-fill"></i>
                                          </button>
                                        </div> */}
                                      </td>
                                      <td className='gridjs-td text-center'>
                                        <label className={`btn custom-checkbox ${ele.blocked === true ? 'btn-danger' : 'btn-success'}`} title={ele.blocked ? 'Inactive User' : 'Active User'}>
                                          <input
                                            checked={ele.blocked}
                                            type="checkbox"
                                            onChange={(e) => onCheckboxChange(e, ele.username, ele.blocked)}
                                          />
                                          <i className="bi bi-ban"></i>
                                        </label>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="11" className="text-center">
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>

                          {showModal && (
                            <>
                              {/* Backdrop */}
                              <div className="modal-backdrop fade show"></div>
                              <div className="modal fade show d-block" tabIndex="-1">
                                <div className="modal-dialog modal-dialog-centered">
                                  <div className="modal-content">
                                    {/* Header */}
                                    <div className="modal-header">
                                      <h5 className="modal-title justify-content-center position-relatives">Update Password</h5>
                                      <button
                                        type="button"
                                        className="btn-close position-absolute end-0 me-3"
                                        onClick={() => setShowModal(false)}
                                      ></button>
                                    </div>
                                    {/* FORM */}
                                    <form
                                      onSubmit={(e) => {
                                        e.preventDefault();
                                        handleUpdatePassword();
                                      }}
                                    >
                                      <div className="modal-body text-center">
                                        <div className="mb-3">
                                          <label className="form-label">Username</label>
                                          <input
                                            type="text"
                                            className="form-control w-75 mx-auto"
                                            value={selectedUserps?.username || ""}
                                            disabled
                                          />
                                        </div>
                                        <div className="mb-3">
                                          <label className="form-label">Old Password</label>
                                          <input
                                            type="text"
                                            className="form-control w-75 mx-auto"
                                            value={selectedUserps?.password || ""}
                                            disabled
                                            autoComplete="current-password"
                                          />
                                        </div>
                                        <div className="mb-3">
                                          <label className="form-label">New Password</label>
                                          <input
                                            type="text"
                                            className="form-control w-75 mx-auto"
                                            placeholder="Enter new password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            autoComplete="new-password"
                                            required
                                          />
                                        </div>
                                      </div>
                                      {/* Footer */}
                                      <div className="modal-footer">
                                        <button
                                          type="button"
                                          className="btn btn-secondary"
                                          onClick={() => setShowModal(false)}
                                        >
                                          Close
                                        </button>
                                        <button
                                          type="submit"
                                          className="btn btn-primary"
                                          disabled={updating}
                                        >
                                          {updating ? "Updating..." : "Save Changes"}
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          {showmailModal && (
                            <>
                              {/* Backdrop */}
                              <div className="modal-backdrop fade show"></div>
                              <div className="modal fade show d-block" tabIndex="-1">
                                <div className="modal-dialog modal-dialog-centered">
                                  <div className="modal-content">
                                    {/* Header */}
                                    <div className="modal-header justify-content-center position-relative">
                                      <h5 className="modal-title">Update Email</h5>
                                      <button
                                        type="button"
                                        className="btn-close position-absolute end-0 me-3"
                                        onClick={() => setShowmailModal(false)}
                                      ></button>
                                    </div>
                                    {/* FORM */}
                                    <form
                                      onSubmit={(e) => {
                                        e.preventDefault();
                                        handleUpdateEmail();
                                      }}
                                    >
                                      <div className="modal-body text-center">
                                        <div className="mb-3">
                                          <label className="form-label">Username</label>
                                          <input
                                            type="text"
                                            className="form-control w-75 mx-auto"
                                            value={selectedUseremail?.username || ""}
                                            disabled
                                          />
                                        </div>
                                        <div className="mb-3">
                                          <label className="form-label">Old Email</label>
                                          <input
                                            type="text"
                                            className="form-control w-75 mx-auto"
                                            value={selectedUseremail?.email || ""}
                                            disabled
                                            autoComplete="current-password"
                                          />
                                        </div>
                                        <div className="mb-3">
                                          <label className="form-label">New Email</label>
                                          <input
                                            type="text"
                                            className="form-control w-75 mx-auto"
                                            placeholder="Enter new Email"
                                            value={newEmail}
                                            onChange={(e) => setNewEmail(e.target.value)}
                                            autoComplete="new-email"
                                            required
                                          />
                                        </div>
                                      </div>
                                      {/* Footer */}
                                      <div className="modal-footer">
                                        <button
                                          type="button"
                                          className="btn btn-secondary"
                                          onClick={() => setShowmailModal(false)}
                                        >
                                          Close
                                        </button>
                                        <button
                                          type="submit"
                                          className="btn btn-primary"
                                          disabled={updatingemail}
                                        >
                                          {updatingemail ? "Updating..." : "Save Changes"}
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {/* Modal */}
                          {selectedUser && (
                            <div className="custom-modal-overlay">
                              <div className="custom-modal">
                                <div className="modal-header">
                                  <h5 className="modal-title">Edit User</h5>
                                  <button type="button" className="close-button" onClick={closeModal}>&times;</button>
                                </div>
                                <div className="modal-body">
                                  <p><strong>User Address:</strong>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="ref_address"
                                      value={editData.username}
                                      disabled // Non-editable
                                    />
                                  </p>
                                  <p><strong>Referral Address:</strong>   <input
                                    type="text"
                                    className="form-control"
                                    name="fromname"
                                    value={editData.ref_address}
                                    onChange={handleChange}
                                  /></p>
                                  <p><strong>Referral Name:</strong>   <input
                                    type="text"
                                    className="form-control"
                                    name="fromname"
                                    value={editData.toname}
                                    onChange={handleChange}
                                    disabled
                                  /></p>
                                  <p><strong>New Referral Address:</strong>   <input
                                    type="text"
                                    className="form-control"
                                    name="fromname"
                                    value={newaddressFilter}
                                    onChange={handleChange}
                                  /></p>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                                  <button type="button" className="btn btn-primary" onClick={updateData}>Save Changes</button>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* CSS for Custom Modal */}
                          <style>
                            {`
                            
                              .custom-modal-overlay {
                              position: fixed;
                              top: 0;
                              left: 0;
                              width: 100%;
                              height: 100%;
                              background: rgba(0, 0, 0, 0.5);
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              z-index: 1050;
                            }
          
                            .custom-modal {
                              background: white;
                              padding: 20px;
                              border-radius: 8px;
                              width: 400px;
                              box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
                              position: relative;
                            }

                            .modal-header {
                              display: flex;
                              justify-content: space-between;
                              align-items: center;
                              border-bottom: 1px solid #ddd;
                              padding-bottom: 10px;
                            }

                            .modal-body {
                              padding: 15px 0;
                            }

                            .modal-footer {
                              display: flex;
                              justify-content: space-between;
                              padding-top: 10px;
                              border-top: 1px solid #ddd;
                            }

                            .close-button {
                              background: none;
                              border: none;
                              font-size: 20px;
                              cursor: pointer;
                            }

                            .switch {
                              position: relative;
                              display: inline-block;
                              width: 52px;
                              height: 29px;
                            }

                            /* Hide default HTML checkbox */
                            .switch input {
                              opacity: 0;
                              width: 0;
                              height: 0;
                            }

                            /* The slider */
                            .slider {
                              position: absolute;
                              cursor: pointer;
                              top: 0; 
                              left: 0;
                              right: 0;
                              bottom: 0;
                              background-color: #ccc;
                              -webkit-transition: .4s;
                              transition: .4s;
                            }

                            .slider:before {
                              position: absolute;
                              content: "";
                              height: 22px;
                              width: 22px;
                              left: 4px;
                              bottom: 4px;
                              background-color: white;
                              -webkit-transition: .4s;
                              transition: .4s;
                            }

                            input:checked + .slider {
                              background-color: #405189;
                            }

                            input:focus + .slider {
                              box-shadow: 0 0 1px #405189;
                            }

                            input:checked + .slider:before {
                              -webkit-transform: translateX(26px);
                              -ms-transform: translateX(26px);
                              transform: translateX(26px);
                            }

                            /* Rounded sliders */
                            .slider.round {
                              border-radius: 34px;
                            }

                            .slider.round:before {
                              border-radius: 50%;
                            }

                            .btn-danger:hover {
                              background-color: #c82333;
                            }

                            .custom-checkbox {
                              position: relative;
                              display: inline-flex;
                              align-items: center;
                              cursor: pointer;  
                            }

                            .custom-checkbox input[type="checkbox"] {
                              opacity: 0;
                              position: absolute;
                              width: 0;
                              height: 0;
                            }

                            .custom-checkbox i {
                              font-size: 18px;
                              color: #fff;
                              transition: transform 0.2s ease;
                            }
                    
                            .custom-modal-overlay {
                               position: fixed;
                               top: 0;
                               left: 0;
                               right: 0;
                               bottom: 0;
                               background: rgba(0, 0, 0, 0.5);
                               display: flex;
                               justify-content: center;
                               align-items: center;
                               z-index: 1000;
                            }

                            .custom-modal {
                               background: #fff;
                               border-radius: 12px;
                               padding: 25px;
                               width: 400px;
                               box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
                               animation: fadeIn 0.3s ease-in-out;
                            }

                            .modal-header {
                               display: flex;
                               justify-content: space-between;
                               align-items: center;
                            }

                            .close-button {
                               background: transparent;
                               border: none;
                               font-size: 1.5rem;
                               cursor: pointer;
                            }

                            .modal-body {
                               margin-top: 15px;
                            }

                            .modal-footer {
                               display: flex;
                               justify-content: flex-end;
                               gap: 10px;
                               margin-top: 20px;
                            }

                            input.form-control:disabled {
                               background-color: #f0f0f0;
                            }

                          `}
                          </style>
                        </div>

                        <Pagination
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pages={pages}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}